import React, { useCallback, useRef } from 'react';
import {
  edgeToEdgeImageSizes,
  useAtBottomOfViewport,
  useInCloseProximityToViewport,
  useScrollToElement,
} from '../../../utils';
import { headerHeight } from '../../../utils/menuHeight';
import Image from '../../generic/Image';
import ImageSpots from '../HotspotHero/ImageSpots';
import { ScrollDistanceContainer, ScrollDistanceElem, OpacityOnScroll } from '../ScrollProgression';

const offset = { yOffset: headerHeight };
let debug = false;

export default function HeroB({ heroImage, hotspotHero, infocardAlternatePos }) {
  let image = edgeToEdgeImageSizes(heroImage.image);
  let intersectionRef = useRef(null);
  let outOfViewportProximity = !useInCloseProximityToViewport(intersectionRef);
  let overlapBottomOfViewport = useAtBottomOfViewport(intersectionRef);
  let { scrollTo } = useScrollToElement(offset);

  let scrollHere = useCallback(() => scrollTo(intersectionRef), [scrollTo]);

  return (
    <>
      <TransitionFadeOnScroll scrollRef={intersectionRef}>
        <ImageSpots
          spots={hotspotHero?.hotspots}
          heroImage={<Image fluid={image.fluid} alt={image.description} />}
          infocardAlternatePos={infocardAlternatePos}
          inViewportProximity={!outOfViewportProximity}
          overlapBottomOfViewport={overlapBottomOfViewport}
          scrollToParent={scrollHere}
        />
      </TransitionFadeOnScroll>

      <ScrollDistanceContainer ref={intersectionRef} isHidden debug={debug}>
        <ScrollDistanceElem image={image} isFullHeight heightMultiplier={1.2} debug={debug} />
      </ScrollDistanceContainer>
    </>
  );
}

function TransitionFadeOnScroll({ children, scrollRef, className = null, style = null }) {
  return (
    <OpacityOnScroll elemRef={scrollRef} className={className} style={style}>
      {children}
    </OpacityOnScroll>
  );
}
